import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {
  GA_BLACKLIST_URLS,
  GA_DATA_MODE_AUTO,
  GA_NON_USER_ROUTES,
} from '../constants/analyticsConstants';
import {useAnalytics} from '../hooks/useAnalytics';
import {RootState} from '../redux/store';
import {
  setUserDetailsGA,
  setUserRole,
} from '../redux/slice/analyticsSlice';
import {
  getGAUserDetailsFromEmail,
  formatRoleNameForGA,
  isCurrentUrlMatch,
} from '../utils/analyticsUtils';

const AnalyticsRouteWatcher = () => {
  const location = useLocation();
  const pathname = location.pathname + location.search;
  const dispatch = useDispatch();
  const {trackGAEvent} = useAnalytics();
  const analyticsUser = useSelector((state: RootState) => state.analytics.user);
  const authenticatedUser = useSelector(
    (state: RootState) => state.authenticatedUser.user
  );

  useEffect(() => {
    if (!authenticatedUser?.emailID || !authenticatedUser?.roleName) {
      return;
    }

    getGAUserDetailsFromEmail(authenticatedUser.emailID).then((details) => {
      dispatch(setUserDetailsGA(details));
      dispatch(setUserRole(formatRoleNameForGA(authenticatedUser.roleName)));
    });
  }, [authenticatedUser?.emailID]);

  useEffect(() => {
    if (isCurrentUrlMatch(location.pathname, GA_BLACKLIST_URLS)) {
      return;
    }

    const isNonUserRoute = GA_NON_USER_ROUTES.includes(location.pathname);
    const hasUser = Boolean(analyticsUser?.id);
    const hasUserRole = Boolean(analyticsUser?.role);

    if (isNonUserRoute && !hasUser) {
      trackGAEvent({page: GA_DATA_MODE_AUTO});
      return;
    }

    if (!isNonUserRoute && hasUser && hasUserRole) {
      trackGAEvent({
        page: GA_DATA_MODE_AUTO,
        user: GA_DATA_MODE_AUTO,
      });
    }
  }, [pathname, analyticsUser]);

  return null;
};

export default AnalyticsRouteWatcher;
